// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cellBody___A6wuC{text-align:left}.groupBy___Pw2m-{border-top:0!important;padding-left:8px!important}div[class^=td].bold___AYve3{font-family:var(--boldFont)}\n", "",{"version":3,"sources":["webpack://./src/components/Table/TBody/RowCell/index.css"],"names":[],"mappings":"AAAA,kBACI,eAAA,CAGJ,iBACI,sBAAA,CACA,0BAAA,CAGJ,4BACQ,2BAAA","sourcesContent":[".cellBody {\n    text-align: left;\n}\n\n.groupBy {\n    border-top: 0 !important;\n    padding-left: 8px !important;\n}\n\ndiv[class^='td'].bold {\n        font-family: var(--boldFont);\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cellBody": "cellBody___A6wuC",
	"groupBy": "groupBy___Pw2m-",
	"bold": "bold___AYve3"
};
export default ___CSS_LOADER_EXPORT___;
